import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = {
    default: String,
    activeClass: String,
    inactiveClass: String,
  };

  declare readonly tabTargets: HTMLElement[];
  declare readonly panelTargets: HTMLElement[];
  declare readonly defaultValue?: string;
  declare readonly activeClassValue?: string;
  declare readonly inactiveClassValue?: string;

  connect() {
    const name =
      this.defaultValue ||
      (this.tabTargets[0] && this.tabTargets[0].dataset.tabsName);

    if (name) this.activate(name);
  }

  change(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const name = target.dataset.tabsName;
    if (name) this.activate(name);
  }

  activate(name: string) {
    // Toggle active tab styles
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tabsName === name) {
        this.applyClasses(tab, this.activeClassValue, this.inactiveClassValue);
      } else {
        this.applyClasses(tab, this.inactiveClassValue, this.activeClassValue);
      }
    });

    // Toggle active panel
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tabsName !== name);
    });
  }

  private applyClasses(el: HTMLElement, add?: string, remove?: string) {
    if (remove) el.classList.remove(...remove.split(" "));
    if (add) el.classList.add(...add.split(" "));
  }
}
